import { render, staticRenderFns } from "./homeNewsList.vue?vue&type=template&id=90138b5e&scoped=true&"
import script from "./homeNewsList.vue?vue&type=script&lang=js&"
export * from "./homeNewsList.vue?vue&type=script&lang=js&"
import style0 from "./homeNewsList.vue?vue&type=style&index=0&id=90138b5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90138b5e",
  null
  
)

export default component.exports